$(function () {
  const $sliders = $('[js-anons-slider]');
  $sliders.each(function() {
    $(this).slick({
      fade: true,
      prevArrow: $('[js-anons-slider-prev]', this.parentElement),
      nextArrow: $('[js-anons-slider-next]', this.parentElement),
    })
  });
})
